<template>
    <AppLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Board Design
            </h2>
        </template>

        <div class="max-w-7xl mx-auto md:grid md:grid-cols-4 md:gap-6">
            <div class="md:col-span-2">
                <div class="p-2">
                    <EditBasic :colors="colors" :palette="palette" :board="board" :errors="errors"/>

                    <div class="hidden sm:block">
                        <div class="py-5">
                            <div class="border-t border-gray-200"></div>
                        </div>
                    </div>

                    <div class="mt-10 sm:mt-0">
                        <EditHero :colors="colors" :palette="palette" :board="board" :errors="errors"/>
                    </div>

                    <div class="hidden sm:block">
                        <div class="py-5">
                            <div class="border-t border-gray-200"></div>
                        </div>
                    </div>

                    <div class="mt-10 sm:mt-0">
                        <EditFooter :colors="colors" :palette="palette" :board="board" :errors="errors"/>
                    </div>
                </div>
            </div>
            <div class="md:col-span-2">
                <div class="p-2">
                    <div class="">
                    <div class="px-4 sm:px-0">
                        <h3 class="text-lg font-medium leading-6 text-gray-900">Preview</h3>
                    </div>
                </div>
                    <div class="bg-white overflow-hidden shadow sm:rounded mt-4">
                    <div class="p-3">
                        <Preview :board="board" :theme="colors" />
                    </div>
                </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import EditHero from "./EditHero";
    import EditFooter from "./EditFooter";
    import EditBasic from "./EditBasic";
    import Preview from "./Preview";
    import AppLayout from "@/Layouts/AppLayout";

    export default {
        components: {
            EditHero,
            EditFooter,
            EditBasic,
            Preview,
            AppLayout,
        },
        props: {
            colors: Object,
            palette: Array,
            board: Object,
            errors: Object
        },
        metaInfo: {title: 'Design'},
        name: "DesignEdit",
    }
</script>
